import * as types from './types';

export default {
  // change loading state
  [types.SET_RESULT](state, params) {
    state.resultMatchesLogs = params;
    state.lastUpdateTimestamp = Date.now();
  },
  [types.PUSH_RESULT](state, result) {
    state.resultMatchesLogs.messages = state.resultMatchesLogs.messages.concat(result);
  },

};
